export const CONTACTS_EMAIL = 'info.blackbot@gmail.com';
export const CONTACTS_TELEGRAM = 'unixvb';
export const CONTACTS_X = '0xblackbot';